var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.046 9.91701C3.57243 10.4076 3.57942 11.1872 4.06173 11.6693C4.54403 12.1513 5.32367 12.1579 5.814 11.684C9.23379 8.27378 14.7682 8.27378 18.188 11.684C18.4223 11.9186 18.7404 12.0503 19.072 12.05C19.7514 12.0528 20.3066 11.5084 20.317 10.829C20.317 10.819 20.317 10.81 20.317 10.8C20.3177 10.4686 20.1859 10.1507 19.951 9.91701C15.555 5.53458 8.44203 5.53458 4.046 9.91701Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.784 6.08799C16.824 0.142138 7.17598 0.142138 1.216 6.08799C0.727783 6.57621 0.727783 7.36777 1.216 7.85599C1.70422 8.34421 2.49578 8.34421 2.984 7.85599C7.96715 2.88566 16.0329 2.88566 21.016 7.85599C21.3318 8.17181 21.7921 8.29516 22.2236 8.17956C22.655 8.06396 22.992 7.72698 23.1076 7.29556C23.2232 6.86413 23.0998 6.40381 22.784 6.08799Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.383 12.033C11.7589 11.1174 8.84236 11.7819 6.87401 13.744C6.51654 14.1014 6.40948 14.6389 6.60275 15.1059C6.79601 15.573 7.25154 15.8777 7.75701 15.878C8.08876 15.8781 8.40689 15.7461 8.64101 15.511C10.4304 13.7344 13.2963 13.6663 15.168 15.356C15.23 15.411 15.299 15.456 15.358 15.511C15.5919 15.7442 15.9087 15.8751 16.239 15.875C16.7444 15.8741 17.1997 15.5692 17.3929 15.1021C17.586 14.6351 17.4792 14.0976 17.122 13.74C16.3502 12.9708 15.4136 12.387 14.383 12.033Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.371C13.3807 22.371 14.5 21.2517 14.5 19.871C14.5 18.4903 13.3807 17.371 12 17.371C10.6193 17.371 9.5 18.4903 9.5 19.871C9.5 21.2517 10.6193 22.371 12 22.371Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.d6b74f40.svg";
export { ForwardRef as ReactComponent };